// import React from "react";

// const features = [
//   {
//     icon: "/images/img_frame.svg",
//     title: "Improve Soil Structure",
//     desc: "Enhance aeration, water retention, and microbial activity.",
//   },
//   {
//     icon: "/images/img_frame_white_a700.svg",
//     title: "Enrich Soil Nutrients",
//     desc: "Supply essential minerals such as nitrogen, phosphorus, and potassium.",
//   },
//   {
//     icon: "/images/img_frame_white_a700_50x50.svg",
//     title: "Boost Crop Yield",
//     desc: "Support healthy root development and plant growth.",
//   },
//   {
//     icon: "/images/img_frame_50x50.svg",
//     title: "Protect Environment",
//     desc: "Decrease soil and water contamination while reducing carbon footprint.",
//   },
// ];

// const WhyChooseUsSection = () => {
//   return (
//     <div className="w-full bg-primary-background">
//       <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex justify-start items-center w-full py-[100px] sm:py-[150px] lg:py-[200px]">
//           <div className="flex flex-col gap-[37px] sm:gap-[55px] lg:gap-[74px] justify-start items-center w-full max-w-[806px] sm:max-w-[1209px] lg:max-w-[1612px] mx-[77px] sm:mx-[115px] lg:mx-[154px]">
//             {/* Section Header */}
//             <div className="flex flex-col gap-[7px] sm:gap-[10px] lg:gap-[14px] justify-start items-start w-full">
//               <div className="flex justify-start items-center w-full">
//                 <p className="text-[12px] sm:text-[18px] lg:text-[24px] font-normal leading-[15px] sm:leading-[23px] lg:leading-[31px] text-left text-white w-auto font-[Sora]">
//                   Why choose us
//                 </p>
//                 <div className="w-[100px] sm:w-[150px] lg:w-[200px] h-[1px] sm:h-[1.5px] lg:h-[2px] bg-white ml-[15px] sm:ml-[22px] lg:ml-[30px]"></div>
//               </div>
//               <h2 className="text-[30px] sm:text-[45px] lg:text-[60px] font-bold leading-[38px] sm:leading-[57px] lg:leading-[76px] text-left text-white w-auto font-[Sora]">
//                 Why Choose Organic Fertilizers?
//               </h2>
//             </div>

//             {/* Features Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[35px] sm:gap-[52px] lg:gap-[70px] w-full">
//               {features.map((item, index) => (
//                 <div
//                   key={index}
//                   className="flex flex-col justify-start items-start w-full max-w-[350px]"
//                 >
//                   <img
//                     src={item.icon}
//                     alt={item.title}
//                     className="w-[25px] sm:w-[37px] lg:w-[50px] h-[25px] sm:h-[37px] lg:h-[50px]"
//                   />
//                   <h3 className="text-[15px] sm:text-[22px] lg:text-[30px] font-bold leading-[19px] sm:leading-[28px] lg:leading-[38px] text-left text-white w-auto mt-[12px] sm:mt-[18px] lg:mt-[24px] font-[Sora]">
//                     {item.title}
//                   </h3>
//                   <p className="text-[12px] sm:text-[18px] lg:text-[24px] font-normal leading-[19px] sm:leading-[28px] lg:leading-[38px] text-justify text-white w-full mt-[6px] sm:mt-[9px] lg:mt-[12px] font-[Sora]">
//                     {item.desc}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhyChooseUsSection;

import React from "react";
import AnimatedFeatureSection from "../../component/common/AnimatedFeatureSection";

const WhyChooseUsSection = () => {
  // Define the specific data for this section
  const featuresData = [
    {
      icon: "/images/aboutImg/icon1.svg",
      title: "Improve Soil Structure",
      description: "Enhance aeration, water retention, and microbial activity.",
      // The unique margins are passed here via className
      className: "mb-[38px] 2xl:mb-[76px]",
    },
    {
      icon: "/images/aboutImg/icon2.svg",
      title: "Enrich Soil Nutrients",
      description:
        "Supply essential minerals such as nitrogen, phosphorus, and potassium.",
      className: "", // No margin
    },
    {
      icon: "/images/aboutImg/icon3.svg",
      title: "Boost Crop Yield",
      description: "Support healthy root development and plant growth.",
      className: "mb-[19px] 2xl:mb-[38px]",
    },
    {
      icon: "/images/aboutImg/icon4.svg",
      title: "Protect  Environment",
      description:
        "Decrease soil and water contamination while reducing carbon footprint.",
      className: "mb-[40px] 2xl:mb-[80px]",
    },
  ];

  return (
    <AnimatedFeatureSection
      subtitle="Offering"
      title="Why Choose Us?"
      features={featuresData}
      // Optional: Overrides (defaults are already set to your original colors)
      bgColor="bg-[#1C233A]"
      textColor="text-text-secondary"
      lineColor="bg-text-secondary"
    />
  );
};

export default WhyChooseUsSection;
